/* eslint-disable max-len */
// diversityOfGovernanceBodiesAndEmployees------------------------------
export const DiversityOfGovernanceBodiesAndEmployeesKey = {
  DOGBE_QUESTION_1: 'dogbeQuestion1',
  DOGBE_QUESTION_2: 'dogbeQuestion2',
  DOGBE_QUESTION_3: 'dogbeQuestion3',
  DOGBE_QUESTION_4: 'dogbeQuestion4',
  DOGBE_QUESTION_5: 'dogbeQuestion5',
  DOGBE_QUESTION_6: 'dogbeQuestion6',
  DOGBE_QUESTION_7: 'dogbeQuestion7',
  DOGBE_QUESTION_8: 'dogbeQuestion8',
  DOGBE_QUESTION_9: 'dogbeQuestion9',

  DOGBE_QUESTION_10: 'dogbeQuestion10',
  DOGBE_QUESTION_11: 'dogbeQuestion11',
  DOGBE_QUESTION_12: 'dogbeQuestion12',
  DOGBE_QUESTION_13: 'dogbeQuestion13',
  DOGBE_QUESTION_14: 'dogbeQuestion14',
  DOGBE_QUESTION_15: 'dogbeQuestion15',
  DOGBE_QUESTION_16: 'dogbeQuestion16',
  DOGBE_QUESTION_17: 'dogbeQuestion17',
  DOGBE_QUESTION_18: 'dogbeQuestion18',
  DOGBE_QUESTION_19: 'dogbeQuestion19',
  DOGBE_QUESTION_20: 'dogbeQuestion20',

  DOGBE_QUESTION_21: 'dogbeQuestion21',
  DOGBE_QUESTION_22: 'dogbeQuestion22',
  DOGBE_QUESTION_23: 'dogbeQuestion23',
  DOGBE_QUESTION_24: 'dogbeQuestion24',
  DOGBE_QUESTION_25: 'dogbeQuestion25',
  DOGBE_QUESTION_26: 'dogbeQuestion26',
  DOGBE_QUESTION_27: 'dogbeQuestion27',
  DOGBE_QUESTION_28: 'dogbeQuestion28',
  DOGBE_QUESTION_29: 'dogbeQuestion29',
  DOGBE_QUESTION_30: 'dogbeQuestion30'
};

export const DiversityOfGovernanceBodiesAndEmployeesLabel = {
  DOGBE_HEADING_1:
    'Percentage of individuals within the organization’s governance bodies in each of the following diversity categories:',
  DOGBE_HEADING_2:
    'Percentage of employees per employee category in each of the following diversity categories:',
  DOGBE_HEADING_3: 'Male -',
  DOGBE_HEADING_4: 'Female -',
  DOGBE_HEADING_5: 'Under 30 years old -',
  DOGBE_HEADING_6: '30-50 years old -',
  DOGBE_HEADING_7: 'Over 50 years old -',

  // DOGBE_HEADING_8: 'Under 30 years old -',
  // DOGBE_HEADING_9: 'Under 30 years old -',
  // DOGBE_HEADING_10: 'Under 30 years old -',

  DOGBE_QUESTION_1: 'Male members on board',
  DOGBE_QUESTION_2: 'Total board members',
  DOGBE_QUESTION_3: 'Female members on board',
  DOGBE_QUESTION_4: 'Total board members',
  DOGBE_QUESTION_5: '30 years old board members',
  DOGBE_QUESTION_6: 'Total board members',
  DOGBE_QUESTION_7: '30-50 years old board members',
  DOGBE_QUESTION_8: 'Total board members',
  DOGBE_QUESTION_9: 'Over 50 years old board members',
  DOGBE_QUESTION_10: 'Total board members',
  DOGBE_QUESTION_11: 'Minority or vulnerable groups board members',
  DOGBE_QUESTION_12: 'Total board members',

  DOGBE_QUESTION_13: 'Male Employees',
  DOGBE_QUESTION_14: 'Female Employees',
  DOGBE_QUESTION_15: '30 years old employees',
  DOGBE_QUESTION_16: '30-50 years old employees',
  DOGBE_QUESTION_17: 'Over 50 years old employees',
  DOGBE_QUESTION_18: 'Minority or vulnerable groups employees',
  DOGBE_QUESTION_19: 'Total Employees',
  DOGBE_QUESTION_20: '',

  DOGBE_QUESTION_21: '',
  DOGBE_QUESTION_22: '',
  DOGBE_QUESTION_23: '',
  DOGBE_QUESTION_24: '',
  DOGBE_QUESTION_25: '',
  DOGBE_QUESTION_26: '',
  DOGBE_QUESTION_27: '',
  DOGBE_QUESTION_28: '',
  DOGBE_QUESTION_29: '',
  DOGBE_QUESTION_30: ''
};

// ratioOfBasicSalaryAndRemunerationOfWomenToMen------------------------------
export const RatioOfBasicSalaryAndRemunerationOfWomenToMenKey = {
  ROBSAROWTM_QUESTION_1: 'robsarowtmQuestion1',
  ROBSAROWTM_QUESTION_2: 'robsarowtmQuestion2',
  ROBSAROWTM_QUESTION_3: 'robsarowtmQuestion3',
  ROBSAROWTM_QUESTION_4: 'robsarowtmQuestion4'
};

export const RatioOfBasicSalaryAndRemunerationOfWomenToMenLabel = {
  ROBSAROWTM_1: 'Ratio of basic salary and remuneration of women to men',
  ROBSAROWTM_QUESTION_1: 'Average total remuneration of male',
  ROBSAROWTM_QUESTION_2: 'Average total remuneration of female',
  ROBSAROWTM_QUESTION_3: '',
  ROBSAROWTM_QUESTION_4: ''
};

// employment----------------------------------
export const EmploymentKey = {
  E_QUESTION_1: 'eQuestion1',
  E_QUESTION_2: 'eQuestion2',
  E_QUESTION_3: 'eQuestion3',
  E_QUESTION_4: 'eQuestion4',
  E_QUESTION_5: 'eQuestion5',
  E_QUESTION_6: 'eQuestion6',
  E_QUESTION_7: 'eQuestion7',
  E_QUESTION_8: 'eQuestion8',
  E_QUESTION_9: 'eQuestion9',
  E_QUESTION_10: 'eQuestion10',

  E_QUESTION_11: 'eQuestion11',
  E_QUESTION_12: 'eQuestion12',
  E_QUESTION_13: 'eQuestion13',
  E_QUESTION_14: 'eQuestion14',
  E_QUESTION_15: 'eQuestion15',
  E_QUESTION_16: 'eQuestion16',
  E_QUESTION_17: 'eQuestion17',
  E_QUESTION_18: 'eQuestion18',
  E_QUESTION_19: 'eQuestion19',
  E_QUESTION_20: 'eQuestion20',

  E_QUESTION_21: 'eQuestion21',
  E_QUESTION_22: 'eQuestion22',
  E_QUESTION_23: 'eQuestion23',
  E_QUESTION_24: 'eQuestion24',
  E_QUESTION_25: 'eQuestion25',
  E_QUESTION_26: 'eQuestion26',
  E_QUESTION_27: 'eQuestion27',
  E_QUESTION_28: 'eQuestion28',
  E_QUESTION_29: 'eQuestion29',
  E_QUESTION_30: 'eQuestion30',

  E_QUESTION_31: 'eQuestion31',
  E_QUESTION_32: 'eQuestion32',
  E_QUESTION_33: 'eQuestion33',
  E_QUESTION_34: 'eQuestion34',
  E_QUESTION_35: 'eQuestion35',
  E_QUESTION_36: 'eQuestion36',
  E_QUESTION_37: 'eQuestion37',
  E_QUESTION_38: 'eQuestion38',
  E_QUESTION_39: 'eQuestion39',
  E_QUESTION_40: 'eQuestion40',

  E_QUESTION_41: 'eQuestion41',
  E_QUESTION_42: 'eQuestion42',
  E_QUESTION_43: 'eQuestion43',
  E_QUESTION_44: 'eQuestion44',
  E_QUESTION_45: 'eQuestion45',
  E_QUESTION_46: 'eQuestion46',
  E_QUESTION_47: 'eQuestion47',
  E_QUESTION_48: 'eQuestion48',
  E_QUESTION_49: 'eQuestion49',
  E_QUESTION_50: 'eQuestion50',

  E_QUESTION_51: 'eQuestion51',
  E_QUESTION_52: 'eQuestion52',
  E_QUESTION_53: 'eQuestion53',
  E_QUESTION_54: 'eQuestion54',
  E_QUESTION_55: 'eQuestion55',
  E_QUESTION_56: 'eQuestion56',
  E_QUESTION_57: 'eQuestion57',
  E_QUESTION_58: 'eQuestion58',
  E_QUESTION_59: 'eQuestion59',
  E_QUESTION_60: 'eQuestion60'
};

export const EmploymentLabel = {
  E_EMPLOYMENT_1: 'New employee hires and employee turnover',
  E_EMPLOYMENT_2:
    'Benefits provided to full-time employees that are not provided to temporary or part-time employees',
  E_EMPLOYMENT_3: 'Parental leave',

  E_HEADING_1: 'Male -',
  E_HEADING_2: 'Female -',
  E_HEADING_3: 'By age group',
  E_HEADING_4: 'By gender',
  E_HEADING_5: 'By region',
  E_HEADING_6: 'Rate of New employee hires :',
  E_HEADING_7: 'Under 30 years old -',
  E_HEADING_8: '30-50 years old -',
  E_HEADING_9: 'over 50 years old -',
  E_HEADING_10: 'Total rate of employee turnover :',
  E_HEADING_11: 'Total rate of employee turnover -',

  E_QUESTION_1: 'Under 30 years old',
  E_QUESTION_2: '30-50 years old',
  E_QUESTION_3: 'over 50 years old',
  E_QUESTION_4: 'Male',
  E_QUESTION_5: 'Female',

  E_QUESTION_6: 'Employee by region',
  E_QUESTION_7: 'New employee hire for under 30 years old',
  E_QUESTION_8: 'Total number of employee hires',
  E_QUESTION_9: 'New employee hire for 30-50 years old',
  E_QUESTION_10: 'Total number of employee hires',

  E_QUESTION_11: 'New employee hire for over 50 years old',
  E_QUESTION_12: 'Total number of employee hires',
  E_QUESTION_13: 'New employee hire Male',
  E_QUESTION_14: 'Total number of employee hires',
  E_QUESTION_15: 'New employee hire Female',
  E_QUESTION_16: 'Total number of employee hires',
  E_QUESTION_17: 'New employee hire for Region',
  E_QUESTION_18: 'Total number of employee hires',
  E_QUESTION_19: 'Under 30 years old',
  E_QUESTION_20: '30-50 years old',

  E_QUESTION_21: 'Over 50 years old',
  E_QUESTION_22: 'Number of employee turnover for under 30 years old',
  E_QUESTION_23: 'Total number of employee under 30 years old',
  E_QUESTION_24: 'Number of employee turnover for 30-50 years old ',
  E_QUESTION_25: 'Total number of employee 30-50 years old',
  E_QUESTION_26: 'Number of employee turnover for over 50 years old',
  E_QUESTION_27: 'Total number of employee over 50 years old',
  E_QUESTION_28: 'Male employee turnover',
  E_QUESTION_29: 'Female employee turnover',
  E_QUESTION_30: 'Male Employee turnover',

  E_QUESTION_31: 'Total male employees',
  E_QUESTION_32: 'Female Employee turnover',
  E_QUESTION_33: 'Total female employees',
  E_QUESTION_34: '',
  E_QUESTION_35: 'Employee turnover in the region',
  E_QUESTION_36: 'Total employees in the region',
  E_QUESTION_37: 'Employee turnover',
  E_QUESTION_38: 'Total employees',
  E_QUESTION_39: '',
  E_QUESTION_40: '',

  E_QUESTION_41: '',
  E_QUESTION_42: '',
  E_QUESTION_43: '',
  E_QUESTION_44: '',
  E_QUESTION_45: '',
  E_QUESTION_46: '',
  E_QUESTION_47: '',
  E_QUESTION_48:
    'Total number of Male employees that did return to work after parental leave',
  E_QUESTION_49:
    'Total number of employees due to return to work after taking parental leave',
  E_QUESTION_50:
    'Total number of Female employees that did return to work after parental leave',

  E_QUESTION_51:
    'Total number of employees due to return to work after taking parental leave',
  E_QUESTION_52:
    'Total number of Male employees retained 12 months after returning to work following a period of parental leave',
  E_QUESTION_53: 'Total number of employees returning from parental leave',
  E_QUESTION_54:
    'Total number of Female employees retained 12 months after returning to work following a period of parental leave',
  E_QUESTION_55: 'Total number of employees returning from parental leave ',
  E_QUESTION_56: '',
  E_QUESTION_57: '',
  E_QUESTION_58: '',
  E_QUESTION_59: '',
  E_QUESTION_60: '',

  E_LABEL_1: 'Male',
  E_LABEL_2: 'Female'
};

// laborManagementRelations----------------------------------
export const LaborManagementRelationsKey = {
  LMR_QUESTION_1: 'lmrQuestion1',
  LMR_QUESTION_2: 'lmrQuestion2',
  LMR_QUESTION_3: 'lmrQuestion3',
  LMR_QUESTION_4: 'lmrQuestion4'
};

export const LaborManagementRelationsLabel = {
  LMR_LABOR_MANAGEMENT_RELATIONS_1:
    'Minimum notice periods regarding operational changes',
  LMR_QUESTION_1: '',
  LMR_QUESTION_2: '',
  LMR_QUESTION_3: '',
  LMR_QUESTION_4: ''
};

// securityPractices----------------------------------
export const SecurityPracticesKey = {
  SP_QUESTION_1: 'spQuestion1',
  SP_QUESTION_2: 'spQuestion2',
  SP_QUESTION_3: 'spQuestion3',
  SP_QUESTION_4: 'spQuestion4'
};

export const SecurityPracticesLabel = {
  SP_SECURITY_PRACTICES_1:
    'Security personnel trained in human rights policies or procedures',
  SP_QUESTION_1:
    'Total no of security personnel received training on human rights',
  SP_QUESTION_2: 'Total security personnel',
  SP_QUESTION_3: '',
  SP_QUESTION_4: ''
};

// rightsOfIndigenousPeoples----------------------------------
export const RightsOfIndigenousPeoplesKey = {
  ROIP_QUESTION_1: 'seQuestion1',
  ROIP_QUESTION_2: 'seQuestion2',
  ROIP_QUESTION_3: 'seQuestion3',
  ROIP_QUESTION_4: 'seQuestion4',
  ROIP_QUESTION_5: 'seQuestion5'
};

export const RightsOfIndigenousPeoplesLabel = {
  ROIP_RIGHTS_OF_INDIGENOUS_PEOPLES_1:
    'Incidents of violations involving rights of indigenous peoples',
  ROIP_HEADING_1: 'i. Incident reviewed by the organization.',
  ROIP_HEADING_2: 'ii. Remediation plans being implemented.',
  ROIP_HEADING_3:
    'iii. Remediation plans that have been implemented, with results reviewed through routine internal management review processes.',
  ROIP_HEADING_4: 'iv. Incident no longer subject to action.',

  ROIP_QUESTION_1: '',
  ROIP_QUESTION_2: '',
  ROIP_QUESTION_3: '',
  ROIP_QUESTION_4: '',
  ROIP_QUESTION_5: ''
};

// humanRightsAssessment----------------------------------
export const HumanRightsAssessmentKey = {
  HRA_QUESTION_1: 'hraQuestion1',
  HRA_QUESTION_2: 'hraQuestion2',
  HRA_QUESTION_3: 'hraQuestion3',
  HRA_QUESTION_4: 'hraQuestion4',
  HRA_QUESTION_5: 'hraQuestion5',
  HRA_QUESTION_6: 'hraQuestion6',
  HRA_QUESTION_7: 'hraQuestion7',
  HRA_QUESTION_8: 'hraQuestion8',
  HRA_QUESTION_9: 'hraQuestion9',
  HRA_QUESTION_10: 'hraQuestion10',

  HRA_QUESTION_11: 'hraQuestion11',
  HRA_QUESTION_12: 'hraQuestion12',
  HRA_QUESTION_13: 'hraQuestion13',
  HRA_QUESTION_14: 'hraQuestion14',
  HRA_QUESTION_15: 'hraQuestion15',
  HRA_QUESTION_16: 'hraQuestion16',
  HRA_QUESTION_17: 'hraQuestion17',
  HRA_QUESTION_18: 'hraQuestion18',
  HRA_QUESTION_19: 'hraQuestion19',
  HRA_QUESTION_20: 'hraQuestion20'
};

export const HumanRightsAssessmentLabel = {
  HRA_HUMAN_RIGHTS_ASSESSMENT_1:
    'Operations that have been subject to human rights reviews or impact assessments',
  HRA_HUMAN_RIGHTS_ASSESSMENT_2:
    'Employee training on human rights policies or procedures',
  HRA_HUMAN_RIGHTS_ASSESSMENT_3:
    'Significant investment agreements and contracts that include human rights clauses or that underwent human rights screening',
  HRA_HEADING_1:
    'Percentage of operations that have been subject to human rights reviews or human rights impact assessments, by country.',
  HRA_HEADING_2:
    'Percentage of significant investment agreements and contracts that include human rights clauses or that underwent human rights screening',
  HRA_QUESTION_1: '',
  HRA_QUESTION_2:
    ' Total number of operations that have been subject to human rights reviews or human rights impact assessments',
  HRA_QUESTION_3: 'Total no of operation',
  HRA_QUESTION_4: '',
  HRA_QUESTION_5:
    'Total number of operations that have been subject to human rights reviews or human rights impact assessments',
  HRA_QUESTION_6: 'Total no. of operation',
  HRA_QUESTION_7: '',
  HRA_QUESTION_8:
    'Total number of significant investment agreements and contracts that include human rights clauses or that underwent human rights screening',
  HRA_QUESTION_9: 'Total number of investment agreements and contracts ',
  HRA_QUESTION_10: '',

  HRA_QUESTION_11: '',
  HRA_QUESTION_12: '',
  HRA_QUESTION_13: '',
  HRA_QUESTION_14: '',
  HRA_QUESTION_15: '',
  HRA_QUESTION_16: '',
  HRA_QUESTION_17: '',
  HRA_QUESTION_18: '',
  HRA_QUESTION_19: '',
  HRA_QUESTION_20: ''
};

// localCommunities----------------------------------
export const LocalCommunitiesKey = {
  LC_QUESTION_1: 'lcQuestion1',
  LC_QUESTION_2: 'lcQuestion2',
  LC_QUESTION_3: 'lcQuestion3',
  LC_QUESTION_4: 'lcQuestion4',
  LC_QUESTION_5: 'lcQuestion5',
  LC_QUESTION_6: 'lcQuestion6',
  LC_QUESTION_7: 'lcQuestion7',
  LC_QUESTION_8: 'lcQuestion8',
  LC_QUESTION_9: 'lcQuestion9',
  LC_QUESTION_10: 'lcQuestion10',

  LC_QUESTION_11: 'lcQuestion11',
  LC_QUESTION_12: 'lcQuestion12',
  LC_QUESTION_13: 'lcQuestion13',
  LC_QUESTION_14: 'lcQuestion14',
  LC_QUESTION_15: 'lcQuestion15',
  LC_QUESTION_16: 'lcQuestion16',
  LC_QUESTION_17: 'lcQuestion17',
  LC_QUESTION_18: 'lcQuestion18',
  LC_QUESTION_19: 'lcQuestion19',
  LC_QUESTION_20: 'lcQuestion20'
};

export const LocalCommunitiesLabel = {
  LC_HEADING_1:
    'The reporting organization shall report the following information:',
  LC_LOCAL_COMMUNITIES_1:
    'Operations with local community engagement, impact assessments, and development programs',
  LC_LOCAL_COMMUNITIES_2:
    'Operations with signifcant actual and potential negative impacts on local communities',
  LC_HEADING_2:
    'i. Social impact assessments, including gender impact assessments, based on participatory processes.',
  LC_HEADING_3: 'ii. Environmental impact assessments and ongoing monitoring.',
  LC_HEADING_4:
    'iii. Public disclosure of results of environmental and social impact assessments.',
  LC_HEADING_5:
    'iv. Local community development programs based on local communities’ needs.',
  LC_HEADING_6:
    ' v. Stakeholder engagement plans based on stakeholder mapping.',
  LC_HEADING_7:
    'vi. Broad based local community consultation committees and processes that include vulnerable groups.',
  LC_HEADING_8:
    'vii. Works councils, occupational health and safety committees and other worker representation bodies to deal with impacts.',
  LC_HEADING_9: 'viii. Formal local community grievance processes.',
  LC_HEADING_10: 'i. The location of the operations.',
  LC_HEADING_11:
    'ii. The significant actual and potential negative impacts of operations.',
  LC_QUESTION_1:
    'Operations with implemented local community engagement, impact assessments, and/or development programs, including  social impact assessments :',
  LC_QUESTION_2: 'Total operations :',
  LC_QUESTION_3:
    'Operations with implemented local community engagement, impact assessments, and/or development programs, including  environmental impact assessments :',
  LC_QUESTION_4: 'Total operations :',
  LC_QUESTION_5:
    'Operations with implemented local community engagement, impact assessments, and/or development programs, including  public disclosure of results of environmental and social impact assessments :',
  LC_QUESTION_6: 'Total operations :',
  LC_QUESTION_7:
    'Operations with implemented local community engagement, impact assessments, and/or development programs, including  local community development programs based on local communities’ needs :',
  LC_QUESTION_8: 'Total operations :',
  LC_QUESTION_9:
    'Operations with implemented local community engagement, impact assessments, and/or development programs, including  stakeholder engagement plans based on stakeholder mapping :',
  LC_QUESTION_10: 'Total operations :',

  LC_QUESTION_11:
    'Operations with implemented local community engagement, impact assessments, and/or development programs, including broad based local community consultation committees and processes that include vulnerable groups',
  LC_QUESTION_12: 'Total operations :',
  LC_QUESTION_13:
    'Operations with implemented local community engagement, impact assessments, and/or development programs, including works councils, occupational health and safety committees and other worker representation bodies to deal with impacts',
  LC_QUESTION_14: 'Total operations :',
  LC_QUESTION_15:
    'Operations with implemented local community engagement, impact assessments, and/or development programs, including formal local community grievance processes :',
  LC_QUESTION_16: 'Total operations :',
  LC_QUESTION_17: '',
  LC_QUESTION_18: '',
  LC_QUESTION_19: '',
  LC_QUESTION_20: ''
};

// marketPresence----------------------------------
export const MarketPresenceKey = {
  MP_QUESTION_1: 'mpQuestion1',
  MP_QUESTION_2: 'mpQuestion2',
  MP_QUESTION_3: 'mpQuestion3',
  MP_QUESTION_4: 'mpQuestion4',
  MP_QUESTION_5: 'mpQuestion5',
  MP_QUESTION_6: 'mpQuestion6',
  MP_QUESTION_7: 'mpQuestion7',
  MP_QUESTION_8: 'mpQuestion8',
  MP_QUESTION_9: 'mpQuestion9',
  MP_QUESTION_10: 'mpQuestion10',

  MP_QUESTION_11: 'mpQuestion11',
  MP_QUESTION_12: 'mpQuestion12',
  MP_QUESTION_13: 'mpQuestion13',
  MP_QUESTION_14: 'mpQuestion14',
  MP_QUESTION_15: 'mpQuestion15',
  MP_QUESTION_16: 'mpQuestion16',
  MP_QUESTION_17: 'mpQuestion17',
  MP_QUESTION_18: 'mpQuestion18',
  MP_QUESTION_19: 'mpQuestion19',
  MP_QUESTION_20: 'mpQuestion20'
};

export const MarketPresenceLabel = {
  MP_MARKET_PRESENCE_1:
    'Ratios of standard entry level wage by gender compared to local minimum wage',
  MP_MARKET_PRESENCE_2:
    'Proportion of senior management hired from the local community',
  MP_QUESTION_1: 'Standard Entry-Level Wage for Men',
  MP_QUESTION_2: 'Standard Entry-Level Wage for Women',
  MP_QUESTION_3: '',
  MP_QUESTION_4: '',
  MP_QUESTION_5: '',
  MP_QUESTION_6: 'Employees hired from local community in management',
  MP_QUESTION_7: 'Total management employees',
  MP_QUESTION_8: '',
  MP_QUESTION_9: '',
  MP_QUESTION_10: '',

  MP_QUESTION_11: '',
  MP_QUESTION_12: '',
  MP_QUESTION_13: '',
  MP_QUESTION_14: '',
  MP_QUESTION_15: '',
  MP_QUESTION_16: '',
  MP_QUESTION_17: '',
  MP_QUESTION_18: '',
  MP_QUESTION_19: '',
  MP_QUESTION_20: ''
};

// freedomOfAssociationAndCollectiveBargaining----------------------------------
export const FreedomOfAssociationAndCollectiveBargainingKey = {
  FOACB_QUESTION_1: 'foacbQuestion1',
  FOACB_QUESTION_2: 'foacbQuestion2',
  FOACB_QUESTION_3: 'foacbQuestion3',
  FOACB_QUESTION_4: 'foacbQuestion4',
  FOACB_QUESTION_5: 'foacbQuestion5',
  FOACB_QUESTION_6: 'foacbQuestion6',
  FOACB_QUESTION_7: 'foacbQuestion7',
  FOACB_QUESTION_8: 'foacbQuestion8'
};

export const FreedomOfAssociationAndCollectiveBargainingLabel = {
  FOACB_1:
    'Operations in which the right to freedom of association and collective bargaining may be at risk',
  FOACB_2:
    'Suppliers in which the right to freedom of association and collective bargaining may be at risk',
  FOACB_HEADING_1:
    'i. Type of operation (such as manufacturing plant) and supplier.',
  FOACB_HEADING_2:
    'ii. Countries or geographic areas with operations and suppliers considered at risk.',
  FOACB_QUESTION_1: '',
  FOACB_QUESTION_2: '',
  FOACB_QUESTION_3: '',
  FOACB_QUESTION_4: '',
  FOACB_QUESTION_5: '',
  FOACB_QUESTION_6: '',
  FOACB_QUESTION_7: '',
  FOACB_QUESTION_8: ''
};

// nonDiscrimination----------------------------------
export const NonDiscriminationKey = {
  ND_QUESTION_1: 'ndQuestion1',
  ND_QUESTION_2: 'ndQuestion2',
  ND_QUESTION_3: 'ndQuestion3',
  ND_QUESTION_4: 'ndQuestion4',
  ND_QUESTION_5: 'ndQuestion5'
};

export const NonDiscriminationLabel = {
  ND_NON_DISCRIMINATION_1:
    'Incidents of discrimination and corrective actions taken',
  ND_HEADING_1: 'i. Incident reviewed by the organization',
  ND_HEADING_2: 'ii. Remediation plans being implemented.',
  ND_HEADING_3:
    'iii. Remediation plans that have been implemented, with results reviewed through routine internal management review processes.',
  ND_HEADING_4: 'iv. Incident no longer subject to action.',

  ND_QUESTION_1: '',
  ND_QUESTION_2: '',
  ND_QUESTION_3: '',
  ND_QUESTION_4: '',
  ND_QUESTION_5: ''
};

// childLabor----------------------------------
export const ChildLaborKey = {
  CL_QUESTION_1: 'clQuestion1',
  CL_QUESTION_2: 'clQuestion2',
  CL_QUESTION_3: 'clQuestion3',
  CL_QUESTION_4: 'clQuestion4',
  CL_QUESTION_5: 'clQuestion5',
  CL_QUESTION_6: 'clQuestion6',
  CL_QUESTION_7: 'clQuestion7',
  CL_QUESTION_8: 'clQuestion8',
  CL_QUESTION_9: 'clQuestion9'
};

export const ChildLaborLabel = {
  CL_NON_DISCRIMINATION_1:
    'Operations considered to have significant risk for incidents of',
  CL_NON_DISCRIMINATION_2:
    'Supplier considered to have significant risk for incidents of',
  CL_NON_DISCRIMINATION_3:
    'Operations considered to have significant risk for incidents of child labor either in terms of',
  CL_NON_DISCRIMINATION_4:
    'Suppliers considered to have significant risk for incidents of child labor either in terms of',
  CL_HEADING_1: 'i. Child labor',
  CL_HEADING_2: 'ii. Young workers exposed to hazardous work',
  CL_HEADING_3:
    'i. Type of operation (such as manufacturing plant) and supplier.',
  CL_HEADING_4:
    'ii. Countries or geographic areas with operations and suppliers considered at risk.',

  CL_QUESTION_1: '',
  CL_QUESTION_2: '',
  CL_QUESTION_3: '',
  CL_QUESTION_4: '',
  CL_QUESTION_5: '',
  CL_QUESTION_6: '',
  CL_QUESTION_7: '',
  CL_QUESTION_8: '',
  CL_QUESTION_9: ''
};

// forcedLabor----------------------------------
export const ForcedLaborKey = {
  FL_QUESTION_1: 'flQuestion1',
  FL_QUESTION_2: 'flQuestion2',
  FL_QUESTION_3: 'flQuestion3',
  FL_QUESTION_4: 'flQuestion4',
  FL_QUESTION_5: 'flQuestion5'
};

export const ForcedLaborLabel = {
  FL_FORCED_LABOR_1:
    'Operations considered to have significant risk for incidents of forced or compulsory labor either in terms of',
  FL_FORCED_LABOR_2:
    'Suppliers considered to have significant risk for incidents of forced or compulsory labor either in terms of',
  FL_FORCED_LABOR_3:
    'Measures taken by the organization in the reporting period intended to contribute to the elimination of all forms of forced or compulsory labor',
  FL_HEADING_1:
    'i. Type of operation (such as manufacturing plant) and supplier',
  FL_HEADING_2:
    'ii. Countries or geographic areas with operations and suppliers considered at risk',

  FL_QUESTION_1: '',
  FL_QUESTION_2: '',
  FL_QUESTION_3: '',
  FL_QUESTION_4: '',
  FL_QUESTION_5: ''
};

// occupationalHealthAndSafety----------------------------------
export const OccupationalHealthAndSafetyKey = {
  OHS_QUESTION_1: 'ohsQuestion1',
  OHS_QUESTION_2: 'ohsQuestion2',
  OHS_QUESTION_3: 'ohsQuestion3',
  OHS_QUESTION_4: 'ohsQuestion4',
  OHS_QUESTION_5: 'ohsQuestion5',
  OHS_QUESTION_6: 'ohsQuestion6',
  OHS_QUESTION_7: 'ohsQuestion7',
  OHS_QUESTION_8: 'ohsQuestion8',
  OHS_QUESTION_9: 'ohsQuestion9',
  OHS_QUESTION_10: 'ohsQuestion10',

  OHS_QUESTION_11: 'ohsQuestion11',
  OHS_QUESTION_12: 'ohsQuestion12',
  OHS_QUESTION_13: 'ohsQuestion13',
  OHS_QUESTION_14: 'ohsQuestion14',
  OHS_QUESTION_15: 'ohsQuestion15',
  OHS_QUESTION_16: 'ohsQuestion16',
  OHS_QUESTION_17: 'ohsQuestion17',
  OHS_QUESTION_18: 'ohsQuestion18',
  OHS_QUESTION_19: 'ohsQuestion19',
  OHS_QUESTION_20: 'ohsQuestion20',

  OHS_QUESTION_21: 'ohsQuestion21',
  OHS_QUESTION_22: 'ohsQuestion22',
  OHS_QUESTION_23: 'ohsQuestion23',
  OHS_QUESTION_24: 'ohsQuestion24',
  OHS_QUESTION_25: 'ohsQuestion25',
  OHS_QUESTION_26: 'ohsQuestion26',
  OHS_QUESTION_27: 'ohsQuestion27',
  OHS_QUESTION_28: 'ohsQuestion28',
  OHS_QUESTION_29: 'ohsQuestion29',
  OHS_QUESTION_30: 'ohsQuestion30'
};

export const OccupationalHealthAndSafetyLabel = {
  OHS_OCCUPATIONAL_HEALTH_AND_SAFETY_1:
    'Occupational health and safety management system',
  OHS_OCCUPATIONAL_HEALTH_AND_SAFETY_2:
    'Hazard identification, risk assessment, and incident investigation',
  OHS_OCCUPATIONAL_HEALTH_AND_SAFETY_3: 'Occupational health services',
  OHS_OCCUPATIONAL_HEALTH_AND_SAFETY_4:
    'Worker participation, consultation, and communication on occupational health and safety',
  OHS_OCCUPATIONAL_HEALTH_AND_SAFETY_5:
    'Worker training on occupational health and safety',
  OHS_OCCUPATIONAL_HEALTH_AND_SAFETY_6: 'Promotion of worker health',
  OHS_OCCUPATIONAL_HEALTH_AND_SAFETY_7:
    'Prevention and mitigation of occupational health and safety impacts directly linked by business relationships',
  OHS_OCCUPATIONAL_HEALTH_AND_SAFETY_8:
    'Workers covered by an occupational health and safety management system',

  OHS_HEADING_1:
    'i. The system has been implemented because of legal requirements and, if so, a list of the requirements.',
  OHS_HEADING_2:
    'ii. The system has been implemented based on recognized risk management and/or management system standards/guidelines and, if so, a list of the standards/guidelines.',
  OHS_HEADING_3:
    'i. How the organization ensures the quality of these processes, including the competency of persons who carry them out.',
  OHS_HEADING_4:
    'ii. How the results of these processes are used to evaluate and continually improve the occupational health and safety management system.',
  OHS_HEADING_5:
    'i. The number of all employees and workers who are not employees but whose work and/or workplace is controlled by the organization, who are covered by such a system.',
  OHS_HEADING_6:
    'The percentage of all employees and workers who are not employees but whose work and/or workplace is controlled by the organization, who are covered by such a system.',
  OHS_HEADING_7:
    'ii. The number of all employees and workers who are not employees but whose work and/or workplace is controlled by the organization, who are covered by such a system that has been internally audited.',
  OHS_HEADING_8:
    'The percentage of all employees and workers who are not employees but whose work and/or workplace is controlled by the organization, who are covered by such a system that has been internally audited.',
  OHS_HEADING_9:
    'iii. The number of all employees and workers who are not employees but whose work and/or workplace is controlled by the organization, who are covered by such a system that has been audited or certified by an external party.',
  OHS_HEADING_10:
    'The percentage of all employees and workers who are not employees but whose work and/or workplace is controlled by the organization, who are covered by such a system that has been audited or certified by an external party.',

  OHS_QUESTION_1: '',
  OHS_QUESTION_2: '',
  OHS_QUESTION_3: '',
  OHS_QUESTION_4: '',
  OHS_QUESTION_5: '',
  OHS_QUESTION_6: '',
  OHS_QUESTION_7: '',
  OHS_QUESTION_8: '',
  OHS_QUESTION_9: '',
  OHS_QUESTION_10: '',

  OHS_QUESTION_11: '',
  OHS_QUESTION_12: '',
  OHS_QUESTION_13: '',
  OHS_QUESTION_14: '',
  OHS_QUESTION_15: '',
  OHS_QUESTION_16: '',
  OHS_QUESTION_17: '',
  OHS_QUESTION_18:
    'The number of all employees and workers who are not employees but whose work and/or workplace is controlled by the organization and who are covered by such a system :',
  OHS_QUESTION_19:
    'Total number of all employees and workers who are not employees but whose work and/or workplace is controlled by the organization :',
  OHS_QUESTION_20: '',

  OHS_QUESTION_21:
    'Internally audited number of all employees and workers who are not employees but whose work and or workplace is controlled by the organization',
  OHS_QUESTION_22:
    'Total number of all employees and workers who are not employees but whose work and or workplace is controlled by the organization',
  OHS_QUESTION_23: '',
  OHS_QUESTION_24:
    'All employees and workers who are not employees but whose work and/or workplace is controlled by the organization, who are covered by such a system that has been audited or certified by an external party',
  OHS_QUESTION_25:
    'Total number of all employees and workers who are not employees but whose work and/or workplace is controlled by the organization',
  OHS_QUESTION_26: '',
  OHS_QUESTION_27: '',
  OHS_QUESTION_28: '',
  OHS_QUESTION_29: '',
  OHS_QUESTION_30: ''
};

// workRelatedInjuries----------------------------------
export const WorkRelatedInjuriesKey = {
  WRI_QUESTION_1: 'wriQuestion1',
  WRI_QUESTION_2: 'wriQuestion2',
  WRI_QUESTION_3: 'wriQuestion3',
  WRI_QUESTION_4: 'wriQuestion4',
  WRI_QUESTION_5: 'wriQuestion5',
  WRI_QUESTION_6: 'wriQuestion6',
  WRI_QUESTION_7: 'wriQuestion7',
  WRI_QUESTION_8: 'wriQuestion8',
  WRI_QUESTION_9: 'wriQuestion9',
  WRI_QUESTION_10: 'wriQuestion10',

  WRI_QUESTION_11: 'wriQuestion11',
  WRI_QUESTION_11_1: 'wriQuestion11_1',
  WRI_QUESTION_12: 'wriQuestion12',
  WRI_QUESTION_12_1: 'wriQuestion12_1',
  WRI_QUESTION_13: 'wriQuestion13',
  WRI_QUESTION_14: 'wriQuestion14',
  WRI_QUESTION_15: 'wriQuestion15',
  WRI_QUESTION_16: 'wriQuestion16',
  WRI_QUESTION_17: 'wriQuestion17',
  WRI_QUESTION_18: 'wriQuestion18',
  WRI_QUESTION_19: 'wriQuestion19',
  WRI_QUESTION_20: 'wriQuestion20',

  WRI_QUESTION_21: 'wriQuestion21',
  WRI_QUESTION_22: 'wriQuestion22',
  WRI_QUESTION_23: 'wriQuestion23',
  WRI_QUESTION_24: 'wriQuestion24',
  WRI_QUESTION_25: 'wriQuestion25',
  WRI_QUESTION_26: 'wriQuestion26',
  WRI_QUESTION_27: 'wriQuestion27',
  WRI_QUESTION_28: 'wriQuestion28',
  WRI_QUESTION_29: 'wriQuestion29',
  WRI_QUESTION_30: 'wriQuestion30',

  WRI_QUESTION_31: 'wriQuestion31',
  WRI_QUESTION_32: 'wriQuestion32',
  WRI_QUESTION_33: 'wriQuestion33'
};

export const WorkRelatedInjuriesLabel = {
  WRI_WORK_RELATED_INJURIES_1: 'For all employees',
  WRI_WORK_RELATED_INJURIES_2:
    'For all workers who are not employees but whose work and/or workplace is controlled by the organization',
  WRI_WORK_RELATED_INJURIES_3:
    'The work-related hazards that pose a risk of high-consequence injury, including',
  WRI_WORK_RELATED_INJURIES_4: 'For all employees',
  WRI_WORK_RELATED_INJURIES_5: 'For all employees',
  WRI_QUESTION_1: '',
  WRI_QUESTION_2: 'Total hours worked',
  WRI_QUESTION_3: 'No. of fatal accidents',
  WRI_QUESTION_4: '',
  WRI_QUESTION_5: 'Total High Consequence Injury',
  WRI_QUESTION_6: 'Total hours worked',

  WRI_QUESTION_7: '',
  WRI_QUESTION_8: 'No. of accidents',
  WRI_QUESTION_9: 'Total hours worked',
  WRI_QUESTION_10: '',

  WRI_QUESTION_11: 'Total number of employees',
  WRI_QUESTION_11_1: 'The number of hours worked',
  WRI_QUESTION_12: 'Total number of Contract employees',
  WRI_QUESTION_12_1: 'The number of hours worked',
  WRI_QUESTION_13: '',
  WRI_QUESTION_14: 'No. of fatal accidents',
  WRI_QUESTION_15: 'Total hours worked',
  WRI_QUESTION_16: '',
  WRI_QUESTION_17: 'Total High Consequence Injury',
  WRI_QUESTION_18: 'Total hours worked',
  WRI_QUESTION_19: '',
  WRI_QUESTION_20: 'No. of accidents',

  WRI_QUESTION_21: 'Total hours worked',
  WRI_QUESTION_22: '',
  WRI_QUESTION_23: 'Total number of employees',
  WRI_QUESTION_24: 'The number of hours worked',
  WRI_QUESTION_25: 'Total number of Contractor employees',
  WRI_QUESTION_26: 'The number of hours worked',
  WRI_QUESTION_27: '',
  WRI_QUESTION_28: '',
  WRI_QUESTION_29: '',
  WRI_QUESTION_30: '',
  WRI_QUESTION_31: '',
  WRI_QUESTION_32: '',
  WRI_QUESTION_33: ''
};

// workRelatedIllHealth----------------------------------
export const WorkRelatedIllHealthKey = {
  WRIH_QUESTION_1: 'wrihQuestion1',
  WRIH_QUESTION_2: 'wrihQuestion2',
  WRIH_QUESTION_3: 'wrihQuestion3',
  WRIH_QUESTION_4: 'wrihQuestion4',
  WRIH_QUESTION_5: 'wrihQuestion5',
  WRIH_QUESTION_6: 'wrihQuestion6',
  WRIH_QUESTION_7: 'wrihQuestion7',
  WRIH_QUESTION_8: 'wrihQuestion8',
  WRIH_QUESTION_9: 'wrihQuestion9',
  WRIH_QUESTION_10: 'wrihQuestion10',
  WRIH_QUESTION_11: 'wrihQuestion11'
};

export const WorkRelatedIllHealthLabel = {
  WRIH_WORK_RELATED_ILL_HEALTH_1: 'For all employees',
  WRIH_WORK_RELATED_ILL_HEALTH_2:
    'For all workers who are not employees but whose work and/or workplace is controlled by the organization',
  WRIH_WORK_RELATED_ILL_HEALTH_3:
    'The work-related hazards that pose a risk of ill health, including',
  WRIH_QUESTION_1: '',
  WRIH_QUESTION_2: '',
  WRIH_QUESTION_3: '',
  WRIH_QUESTION_4: '',
  WRIH_QUESTION_5: '',
  WRIH_QUESTION_6: '',
  WRIH_QUESTION_7: '',
  WRIH_QUESTION_8: '',
  WRIH_QUESTION_9: '',
  WRIH_QUESTION_10: '',
  WRIH_QUESTION_11: ''
};

// trainingAndEducation----------------------------------
export const TrainingAndEducationKey = {
  TAE_QUESTION_1: 'taeQuestion1',
  TAE_QUESTION_2: 'taeQuestion2',
  TAE_QUESTION_3: 'taeQuestion3',
  TAE_QUESTION_4: 'taeQuestion4',
  TAE_QUESTION_5: 'taeQuestion5',
  TAE_QUESTION_6: 'taeQuestion6'
};

export const TrainingAndEducationLabel = {
  TAE_TRAINING_AND_EDUCATION_1:
    'Average hours of training per year per employee',
  TAE_TRAINING_AND_EDUCATION_2:
    'Programs for upgrading employee skills and transition assistance programs',
  TAE_TRAINING_AND_EDUCATION_3:
    'Percentage of employees receiving regular performance and career development reviews',
  TAE_QUESTION_1: '',
  TAE_QUESTION_2: '',
  TAE_QUESTION_3:
    'Employees receiving regular performance and career development reviews',
  TAE_QUESTION_4: 'Total employees',
  TAE_QUESTION_5: 'Male employees',
  TAE_QUESTION_6: 'Female employees'
};

// supplierSocialAssessment----------------------------------
export const SupplierSocialAssessmentKey = {
  SSA_QUESTION_1: 'ssaQuestion1',
  SSA_QUESTION_2: 'ssaQuestion2',
  SSA_QUESTION_3: 'ssaQuestion3',
  SSA_QUESTION_4: 'ssaQuestion4',
  SSA_QUESTION_5: 'ssaQuestion5',
  SSA_QUESTION_6: 'ssaQuestion6',
  SSA_QUESTION_7: 'ssaQuestion7',
  SSA_QUESTION_8: 'ssaQuestion8',
  SSA_QUESTION_9: 'ssaQuestion9',
  SSA_QUESTION_10: 'ssaQuestion10'
};

export const SupplierSocialAssessmentLabel = {
  SSA_SUPPLIER_SOCIAL_ASSESSMENT_1:
    'New suppliers that were screened using social criteria',
  SSA_SUPPLIER_SOCIAL_ASSESSMENT_2:
    'Negative social impacts in the supply chain and actions taken',
  SSA_QUESTION_1: 'Suppliers assessed using social criteria',
  SSA_QUESTION_2: 'Total suppliers',
  SSA_QUESTION_3: '',
  SSA_QUESTION_4: '',
  SSA_QUESTION_5: '',
  SSA_QUESTION_6: 'Suppliers having negative social impacts',
  SSA_QUESTION_7: 'Total suppliers assessed social criteria',
  SSA_QUESTION_8: 'Why?',
  SSA_QUESTION_9:
    'Suppliers identified as having significant actual and potential negative social impacts with which relationships were terminated as a result of assessment',
  SSA_QUESTION_10: 'Total suppliers assessed social criteria'
};

// customerHealthAndSafety----------------------------------
export const CustomerHealthAndSafetyKey = {
  CHAS_QUESTION_1: 'chasQuestion1',
  CHAS_QUESTION_2: 'chasQuestion2',
  CHAS_QUESTION_3: 'chasQuestion3',
  CHAS_QUESTION_4: 'chasQuestion4',
  CHAS_QUESTION_5: 'chasQuestion5',
  CHAS_QUESTION_6: 'chasQuestion6'
};

export const CustomerHealthAndSafetyLabel = {
  CHAS_CUSTOMER_HEALTH_AND_SAFETY_1:
    'Assessment of the health and safety impacts of product and service categories',
  CHAS_CUSTOMER_HEALTH_AND_SAFETY_2:
    'Incidents of non-compliance concerning the health and safety impacts of products and services',
  CHAS_HEADING_1:
    'i. Incidents of non-compliance with regulations resulting in a fine or penalty.',
  CHAS_HEADING_2:
    'ii. Incidents of non-compliance with regulations resulting in a warning.',
  CHAS_HEADING_3: 'iii. Incidents of non-compliance with voluntary codes.',
  CHAS_QUESTION_1: 'Assessed health and safety impacts of product and service',
  CHAS_QUESTION_2: 'Total number of product and service',
  CHAS_QUESTION_3: '',
  CHAS_QUESTION_4: '',
  CHAS_QUESTION_5: '',
  CHAS_QUESTION_6: ''
};

// customerPrivacy----------------------------------
export const CustomerPrivacyKey = {
  CP_QUESTION_1: 'cpQuestion1',
  CP_QUESTION_2: 'cpQuestion2',
  CP_QUESTION_3: 'cpQuestion3',
  CP_QUESTION_4: 'cpQuestion4'
};

export const CustomerPrivacyLabel = {
  CP_CUSTOMER_PRIVACY_1:
    'Substantiated complaints concerning breaches of customer privacy and losses of customer data',
  CP_HEADING_1:
    'i. Complaints received from outside parties and substantiated by the organization.',
  CP_HEADING_2: 'ii. Complaints from regulatory bodies.',

  CP_QUESTION_1: '',
  CP_QUESTION_2: '',
  CP_QUESTION_3: '',
  CP_QUESTION_4: ''
};

// socioeconomicCompliance----------------------------------
export const SocioeconomicComplianceKey = {
  SC_QUESTION_1: 'scQuestion1',
  SC_QUESTION_2: 'scQuestion2',
  SC_QUESTION_3: 'scQuestion3',
  SC_QUESTION_4: 'scQuestion4',
  SC_QUESTION_5: 'scQuestion5'
};

export const SocioeconomicComplianceLabel = {
  SC_SOCIOECONOMIC_COMPLIANCE_1:
    'Non-compliance with laws and regulations in the social and economic area',
  SC_HEADING_1: 'i. Total monetary value of significant fines.',
  SC_HEADING_2: 'ii. Total number of non-monetary sanctions.',
  SC_HEADING_3: 'iii. Cases brought through dispute resolution mechanisms',

  SC_QUESTION_1: '',
  SC_QUESTION_2: '',
  SC_QUESTION_3: '',
  SC_QUESTION_4: '',
  SC_QUESTION_5: ''
};
